module.exports = __webpack_public_path__ + "static/media/request-treatment-enterprise.36bce0d7.png";